// extracted by mini-css-extract-plugin
var _1 = "Button_accent__20edf";
var _2 = "Button_active__d2deb";
var _3 = "Button_base__c25f3";
var _4 = "Button_button__65ffd";
var _5 = "Button_content__87af6";
var _6 = "Button_disabled__8572d";
var _7 = "Button_fluid__f62ce";
var _8 = "Button_free__4929a";
var _9 = "Button_ghost__0536c";
var _a = "Button_gradient__d959e";
var _b = "Button_group__12b96";
var _c = "Button_icon-large__92478";
var _d = "Button_icon-medium__2f980";
var _e = "Button_icon-mini__d3b10";
var _f = "Button_icon-xmini__ccfc7";
var _10 = "Button_inheritColor__f8905";
var _11 = "Button_inverted__9d42e";
var _12 = "Button_large__47fc4";
var _13 = "Button_loading__27c89";
var _14 = "Button_medium__6f5d5";
var _15 = "Button_mini__aec75";
var _16 = "Button_primary__4ede4";
var _17 = "Button_round__60d5f";
var _18 = "Button_secondary__88289";
var _19 = "Button_selected__13fd2";
var _1a = "Button_xmini__41e1a";
export { _1 as "accent", _2 as "active", _3 as "base", _4 as "button", _5 as "content", _6 as "disabled", _7 as "fluid", _8 as "free", _9 as "ghost", _a as "gradient", _b as "group", _c as "icon-large", _d as "icon-medium", _e as "icon-mini", _f as "icon-xmini", _10 as "inheritColor", _11 as "inverted", _12 as "large", _13 as "loading", _14 as "medium", _15 as "mini", _16 as "primary", _17 as "round", _18 as "secondary", _19 as "selected", _1a as "xmini" }
